import { render } from "./App.vue?vue&type=template&id=86651d16"
const script = {}

import "./App.vue?vue&type=style&index=0&id=86651d16&lang=css"

import exportComponent from "/builds/it60371727/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__